import { useState } from 'react';
import Button from '../../components/Button';
import CitiesGrid from '../../components/cities/CitiesGrid';
import CitySearch from '../../components/cities/CitySearch';
import PageSeo from '../../components/PageSeo';
import Spinner from '../../components/Spinner';
import { useBlocksStore } from '../../hooks/useBlocksStore';
import { useCitiesStore } from '../../hooks/useCitiesStore';
import defaultBlocksInCity from '../../utils/defaultBlocksInCity';

export default function CitiesPage() {
  return (
    <>
      <PageSeo
        title='Shitty Cities'
        description='Shitty Cities is the first and shittiest isometric city builder NFT collection on the Algorand blockchain.'
      />
      <InnerCitiesPage />
    </>
  );
}

const InnerCitiesPage = () => {
  const { allCities, loading } = useCitiesStore();
  const { allBlocks, loading: allBlocksLoading } = useBlocksStore();
  const [query, setQuery] = useState('');
  const [sortBy, setSortBy] = useState('mint_date');
  const [numberOfBlocks, setNumberOfBlocks] = useState('');
  const [upgrade, setUpgrade] = useState('');
  const [filterByRentable, setFilterByRentable] = useState(false);

  const onFilterByRentable = () => {
    setFilterByRentable(!filterByRentable);
  };

  const onUpgrade = (upgrade) => {
    setUpgrade(upgrade);
  };

  const filteredCities = allCities
    .filter((city) => {
      const queryFilter = (city.params.name || '').toLowerCase().includes(query.toLowerCase());
      return queryFilter;
    })
    .filter((city) => {
      if (!numberOfBlocks) return true;

      const meta = city.metadata?.properties;

      const blocksForImage = [...defaultBlocksInCity].map((block) => {
        if (!meta?.[`Block #${block.index}`]) return block;
        const id = meta?.[`Block #${block.index}`].split(' - ')[1];
        if (!id) return block;
        const blockData = allBlocks.find((block) => block.index === parseInt(id));
        return { ...block, block: blockData };
      });
      const numberOfFilledBlocks = blocksForImage.filter((block) => block.block).length;

      return numberOfFilledBlocks === parseInt(numberOfBlocks);
    })
    .filter((city) => {
      if (!filterByRentable) return true;
      return (city.citizens || []).length + (city.renters || []).length < city.maxPopulation && city.maxPopulation !== 0;
    })
    .filter((city) => {
      if (!upgrade) return true;
      return city.metadata?.properties?.['Upgrade'] === upgrade;
    })
    .sort((a, b) => {
      if (sortBy === 'mint_date') {
        return a.index - b.index;
      } else if (sortBy === 'population') {
        return (b.citizens || []).length - (a.citizens || []).length;
      } else if (sortBy === 'rarity_score') {
        return b.rarityScore - a.rarityScore;
      }
    });

  if (loading || allBlocksLoading) {
    return (
      <div className='mt-20'>
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <div className='px-4 lg:px-8 mb-12'>
        <div className='mb-6 flex justify-between lg:items-end flex-col lg:flex-row gap-5 mt-5'>
          <div className='flex flex-col space-y-1'>
            <h1 className='text-2xl font-bold'>Shitty Cities</h1>
            <p className='text-sm text-neutral-600'>
              Showing <span className='font-bold'>{filteredCities.length}</span> results
            </p>
          </div>
          <div className='flex flex-col lg:flex-row gap-4'>
            {process.env.NEXT_PUBLIC_LEASING_IS_ENABLED === 'true' && (
              <Button theme={filterByRentable ? 'primary' : 'outline-gray-dark'} className='min-h-[50px]' onClick={onFilterByRentable}>
                Rent Space
              </Button>
            )}
            <Button theme='outline-gray-dark' link href='/marketplace?collection=Shitty Cities' className='min-h-[50px]'>
              For Sale
            </Button>
            <CitySearch onQuery={setQuery} onSortBy={setSortBy} onNumberOfBlocks={setNumberOfBlocks} onUpgrade={onUpgrade} />
          </div>
        </div>
        <CitiesGrid cities={filteredCities} />
      </div>
    </div>
  );
};
